import { useCallback, useEffect, useState } from "react";
import { getCompany } from "../../services/requests/ApiRequests";

const useFetchCompany = ({ skip = 0, limit = 20 }) => {
    const [company, setCompany] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchCompany = useCallback(async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await getCompany(skip, limit);
            const companyData = response.data;

            if (Array.isArray(companyData?.cash_registers)) {
                companyData.cash_registers.reverse();
            }

            setCompany(companyData);
        } catch (err) {
            setError(err);
            console.error("Failed to fetch company:", err);
            setCompany(null);
        } finally {
            setLoading(false);
        }
    }, [skip, limit]);

    useEffect(() => {
        fetchCompany();
    }, [fetchCompany]);

    const refetch = useCallback(() => {
        fetchCompany();
    }, [fetchCompany]);

    return {
        company,
        loading,
        error,
        refetch,
    };
};

export default useFetchCompany;
